'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _log = require('utils/log');

var _log2 = _interopRequireDefault(_log);

var _googleAnalytics = require('./analytics/google-analytics');

var _googleAnalytics2 = _interopRequireDefault(_googleAnalytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TAG = 'GA';
var USE_EXTERNAL_SCRIPT = false;

var GA = function () {
  function GA() {
    (0, _classCallCheck3.default)(this, GA);
    this.trackerName = 'dev';

    if (typeof window !== 'undefined' && !window.ga) {
      /* eslint-disable */
      if (USE_EXTERNAL_SCRIPT) {
        (function (i, s, o, g, r, a, m) {
          i['GoogleAnalyticsObject'] = r;i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments);
          }, i[r].l = 1 * new Date();a = s.createElement(o), m = s.getElementsByTagName(o)[0];a.async = 1;a.src = g;m.parentNode.insertBefore(a, m);
        })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
      } else {
        window.ga = window.ga || function () {
          (ga.q = ga.q || []).push(arguments);
        };ga.l = +new Date();
        (0, _googleAnalytics2.default)();
      }
      /* eslint-enable */
    }

    this.debug = __DEVELOPMENT__;
    this.trackers = {};
  }

  /**
   * init:
   * GA initialize
   * @param {string} trackingId - GA key
   * @param {Object} fieldsObject
   * @param {string} [fieldsObject.name] - GA tracker name, default is "dev"
   * @param {string} [fieldsObject.cookieDomain] - GA cookie domain
   * @param {boolean} [debug] - debug mode
   */


  (0, _createClass3.default)(GA, [{
    key: 'init',
    value: function init(trackingId, fieldsObject) {
      var debug = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __DEVELOPMENT__;

      if (!trackingId) {
        return _log2.default.w(TAG, 'gaTrackingID is required in init()');
      }
      if (typeof window === 'undefined') {
        return _log2.default.w(TAG, 'GA init error: window is undefined');
      }

      this.debug = debug;
      var defaultFields = { trackingId: trackingId, cookieDomain: 'auto' };
      if (fieldsObject.name) {
        this.to(fieldsObject.name);
      }
      this.trackers[this.trackerName] = trackingId;

      var params = (0, _extends3.default)({}, defaultFields, fieldsObject);
      window.ga('create', params);
      _log2.default.i(TAG, 'create', params);

      if (this.debug) {
        window.ga(function (tracker) {
          return _log2.default.i(TAG, 'ready', tracker.get('clientId'));
        });
        _log2.default.i(TAG, 'GA created for tracking name = ' + this.trackerName + ' with key = ' + trackingId);
      }

      _log2.default.d(TAG, 'GA trackers', this.trackers);

      return this;
    }

    /**
     * to:
     * GA set current analytics tracker name
     * @param {string} trackerName - name of the current tracker
     */

  }, {
    key: 'to',
    value: function to(trackerName) {
      this.trackerName = trackerName;
      return this;
    }

    /**
     * ga:
     * Returns the original GA object.
     */

  }, {
    key: 'set',


    /**
     * set:
     * GA tracker set method
     * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
     */
    value: function set(fieldsObject) {
      if (!window.ga) {
        return this;
      }

      if (!fieldsObject) {
        _log2.default.w(TAG, '`fieldsObject` is required in .set()');
        return this;
      }

      if ((typeof fieldsObject === 'undefined' ? 'undefined' : (0, _typeof3.default)(fieldsObject)) !== 'object') {
        _log2.default.w(TAG, 'Expected `fieldsObject` arg to be an Object');
        return this;
      }

      if (!(0, _keys2.default)(fieldsObject).length) {
        _log2.default.w(TAG, 'empty `fieldsObject` given to .set()');
      }

      window.ga(this.trackerName + '.set', fieldsObject);

      if (this.debug) {
        _log2.default.i(TAG, 'called ga(\'' + this.trackerName + '.set\', fieldsObject) with fieldsObject: ', fieldsObject);
      }

      return this;
    }

    /**
     * send:
     * Clone of the low level `ga.send` method
     * WARNING: No validations will be applied to this
     * @param  {Object} fieldObject - field object for tracking different analytics
     */

  }, {
    key: 'send',
    value: function send(fieldObject) {
      if (!window.ga) {
        return this;
      }

      window.ga(this.trackerName + '.send', fieldObject);

      if (this.debug) {
        _log2.default.i(TAG, 'called ga(\'' + this.trackerName + '.send\', fieldObject); with fieldObject: ', fieldObject);
      }

      return this;
    }

    /**
     * pageview:
     * Basic GA pageview tracking
     * @param  {String} path - the current page page e.g. '/about'
     */

  }, {
    key: 'pageview',
    value: function pageview() {
      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';

      if (!window.ga) {
        return this;
      }

      if (!path) {
        _log2.default.w(TAG, 'path is required in .pageview()');
        return this;
      }

      window.ga(this.trackerName + '.send', 'pageview', path);

      if (this.debug) {
        _log2.default.i(TAG, 'called ga(\'' + this.trackerName + '.send\', \'pageview\', path); with path: ' + path);
      }

      return this;
    }

    /**
     * event:
     * GA event tracking
     * @param args.category {String} required
     * @param args.action {String} required
     * @param args.label {String} optional
     * @param args.value {Int} optional
     * @param args.nonInteraction {boolean} optional
     */

  }, {
    key: 'event',
    value: function event(_ref) {
      var category = _ref.category,
          action = _ref.action,
          label = _ref.label,
          value = _ref.value,
          transport = _ref.transport,
          nonInteraction = _ref.nonInteraction;

      if (!window.ga) {
        return this;
      }

      // Simple Validation
      if (!category || !action) {
        _log2.default.w(TAG, 'args.category AND args.action are required in event()');
        return this;
      }

      // Required Fields
      var fieldObject = {
        hitType: 'event',
        eventCategory: category,
        eventAction: action
      };

      // Optional Fields
      if (label) {
        fieldObject.eventLabel = label;
      }

      if (value) {
        if (typeof value !== 'number') {
          _log2.default.w(TAG, 'Expected `args.value` arg to be a Number.');
        } else {
          fieldObject.eventValue = value;
        }
      }

      if (nonInteraction) {
        fieldObject.nonInteraction = !!nonInteraction;
      }

      if (transport) {
        if (typeof transport !== 'string') {
          _log2.default.w(TAG, '`args.transport` must be a string.');
        } else {
          if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
            _log2.default.w(TAG, '`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
          }

          fieldObject.transport = transport;
        }
      }

      // Send to GA
      return this.send(fieldObject);
    }

    /**
     * exception:
     * GA exception tracking
     * @param args.description {String} optional
     * @param args.fatal {boolean} optional
     */

  }, {
    key: 'exception',
    value: function exception(_ref2) {
      var description = _ref2.description,
          _ref2$fatal = _ref2.fatal,
          fatal = _ref2$fatal === undefined ? false : _ref2$fatal;

      if (!window.ga) {
        return this;
      }

      // Required Fields
      var fieldObject = {
        hitType: 'exception'
      };

      // Optional Fields
      if (description) {
        try {
          fieldObject.exDescription = (0, _stringify2.default)({
            page: document.location.href,
            description: description
          });
        } catch (err) {
          _log2.default.w(TAG, 'Can not convert error object to JSON', description);
        }
      }

      fieldObject.exFatal = fatal;

      // Send to GA
      return this.send(fieldObject);
    }
  }], [{
    key: 'ga',
    value: function ga() {
      var _window;

      if (!window.ga) {
        return this;
      }

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_window = window).ga.apply(_window, args);
      if (this.debug) {
        _log2.default.i(TAG, 'called ga(\'arguments\'); with arguments: ', args);
      }

      return window.ga;
    }
  }]);
  return GA;
}();

exports.default = new GA();
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/GA/ga.js
// module id = 2013
// module chunks = 1